export const css = {
	root: '_1JPJOxvD',
	pane: '_18Ps71y8',
	heading: 'XyU7lafk',
	body: '_2M_o71aQ',
	exit: '_1uRiGJ6X',
	collapse: '_2oyLZlXy',
	enter: '_1a3jK8Xk',
	expand: '_2UTQ0lTG',
	' _key': 'base-widgets/accordion2'
};

export default css;
